import { Component } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'ezlocator-admin-web';

  constructor ( private router: Router, private meta: Meta ) {

  }

  ngOnInit() {
    if (environment.NOINDEX) {
      this.meta.addTag({ name: 'robots', content: 'noindex, nofollow' });
    }

    const bc = new BroadcastChannel("ezlo-admin");
    bc.onmessage = (event) => {
      bc.close()
      if(event.data == 'logout')
      {
        setTimeout(() => {
          this.router.navigate(['login'])
        }, 1000);
      }
    }
  }
}
